<template>
    <form ref="form" :action="action" :method="formMethod" @submit.prevent.once="submit" enctype="multipart/form-data">
        <input type="hidden" name="_method" :value="fieldMethod" v-if="fieldMethod"/>
        <csrf></csrf>
        <slot></slot>
    </form>
</template>

<script>
export default {
    name: "SubmitOnceForm",
    inheritAttrs: true,
    props: {
        'action': {
            type: String,
            required: true
        },
        'method': {
            type: String,
            default: 'POST'
        }
    },
    computed: {
        formMethod: function () {
            if (this.method.toUpperCase() === 'GET') {
                return 'GET';
            }
            return 'POST';
        },
        fieldMethod: function () {
            switch (this.method.toUpperCase()) {
                case 'POST':
                case 'GET':
                    return null;
                default:
                    return this.method.toUpperCase();
            }
        }
    },
    methods: {
        submit: function () {
            this.$log.debug("Submit form")
            this.$refs.form.submit();
        }
    }
}
</script>

<style scoped>

</style>
